module.exports = __webpack_public_path__ + "static/media/VIP_Message_Background@3x.2fd9c58e.png";